import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import { getBridgeGitContext, listRepoBranchesForBridge } from '../../git/bridge-git-context.js';

export interface BridgeGitContextRequestMessage {
  id: string;
}

export interface ListRepoBranchesRequestMessage {
  id: string;
  repoRelPath?: string;
}

export function handleBridgeGitContextRequestMessage(
  msg: BridgeGitContextRequestMessage,
  getWs: () => WebSocket | null,
): void {
  void (async () => {
    const socket = getWs();
    if (!socket) return;
    try {
      const repos = await getBridgeGitContext();
      sendWsMessage(socket, { type: 'bridge_git_context_response', id: msg.id, repos });
    } catch (e) {
      sendWsMessage(socket, {
        type: 'bridge_git_context_response',
        id: msg.id,
        error: e instanceof Error ? e.message : String(e),
      });
    }
  })();
}

export function handleListRepoBranchesRequestMessage(
  msg: ListRepoBranchesRequestMessage,
  getWs: () => WebSocket | null,
): void {
  void (async () => {
    const socket = getWs();
    if (!socket) return;
    const repoRelPath = typeof msg.repoRelPath === 'string' ? msg.repoRelPath.trim() : '';
    if (!repoRelPath) {
      sendWsMessage(socket, {
        type: 'list_repo_branches_response',
        id: msg.id,
        error: 'repoRelPath required',
      });
      return;
    }
    try {
      const branches = await listRepoBranchesForBridge(repoRelPath);
      sendWsMessage(socket, { type: 'list_repo_branches_response', id: msg.id, branches });
    } catch (e) {
      sendWsMessage(socket, {
        type: 'list_repo_branches_response',
        id: msg.id,
        error: e instanceof Error ? e.message : String(e),
      });
    }
  })();
}
